enum WSEvents {
  UPDATE_CONFIG = 'UpdateConfig',
}
export default WSEvents;
